module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.b4c75b77005daac83880.js");
}
